import data from "./data.json";
import { statusList, statusType } from "./type";

/**
 * @description clase para obtener los estados de transferencias y pagos
 */
export class statusService {
  private data: statusList = data;

  /**
   * @description aplica filtros a una lista de estados
   * @param list
   * @param code
   * @param name
   * @param rol
   * @returns
   */
  private applyFilters(
    list: statusType[],
    code?: string | null,
    name?: string | null,
    rol?: string | null
  ): statusType[] {
    return list.filter((item) => {
      // Solo filtra por code si tiene valor
      if (code !== null && code !== undefined && item.code !== code) {
        return false;
      }

      // Solo filtra por name si tiene valor
      if (
        name !== null &&
        name !== undefined &&
        !item.name.toLowerCase().includes(name.toLowerCase())
      ) {
        return false;
      }

      // Solo filtra por rol si tiene valor
      if (rol !== null && rol !== undefined) {
        const r = rol.toLowerCase();
        if (!item.rol.some((x) => x.toLowerCase() === r)) {
          return false;
        }
      }

      return true;
    });
  }

  /**
   * @description obtiene los codigos de transferencias y pagos, por codigo, nombre y rol
   * @param code
   * @param name
   * @param rol
   * @param type
   * @example getOnlyCodes("XTI", "Pendiente", "Cliente")
   * @example2 getOnlyCodes("PAG", "Pagado", null, "payment")
   * @returns ['XTI', 'PAG', 'PEN']
   */
  getOnlyCodes(
    code?: string | null,
    name?: string | null,
    rol?: string | null,
    type: "transfer" | "payment" | "all" = "all"
  ): string[] {
    let lista: statusType[];

    switch (type) {
      case "payment":
        lista = this.getPayments(code, name, rol);
        break;
      case "transfer":
        lista = this.getTransfers(code, name, rol);
        break;
      default:
        lista = this.getAll(code, name, rol);
    }

    return lista.map((m) => m.code);
  }

  /**
   * @description obtiene todos los estados, por codigo, nombre y rol
   * @param code
   * @param name
   * @param rol
   * @returns
   */
  getAll(
    code?: string | null,
    name?: string | null,
    rol?: string | null
  ): statusType[] {
    const all = [...this.data.transfers, ...this.data.payment];
    return this.applyFilters(all, code, name, rol);
  }

  /**
   * @description obtiene los estados de transferencias, por codigo, nombre y rol
   * @param code  codigo de la estado
   * @param name  nombre de la estado
   * @param rol   rol del estado
   * @returns
   * @example getTransfers("XTI", "Pendiente", "Cliente")
   * @onExit [{
   *   "code": "XTI",
   *   "name": "Pendiente",
   *   "rol": ["Cliente"]
   * }]
   */
  getTransfers(
    code?: string | null,
    name?: string | null,
    rol?: string | null
  ): statusType[] {
    return this.applyFilters(this.data.transfers, code, name, rol);
  }

  /**
   * @description obtiene los estados de pagos, por codigo, nombre y rol
   * @param code  codigo del estado
   * @param name  nombre del estado
   * @param rol   rol del estado
   * @example getPayments("XAI", "Pendiente", "Analista")
   * @returns [{
   *   "code": "XAI",
   *   "name": "Abono Ingresado",
   *   "rol": ["Cliente", "Apoderado", "Banquero"]
   * }]
   */
  getPayments(
    code?: string | null,
    name?: string | null,
    rol?: string | null
  ): statusType[] {
    return this.applyFilters(this.data.payment, code, name, rol);
  }
}
